module.exports = __webpack_public_path__ + "static/media/preview_private_course_B.460fb50b.png";